import { UseFieldArrayReturn } from 'react-hook-form';
import {
    Box,
    Grid,
    Typography,
    useAppSelector,
    useTheme,
    PargodaInfoIcon,
} from '../../../../base';
import {
    ISaveJobForm,
    IJobRequirementOption,
    ISaveJobRequirement,
    SAVE_JOB_FORM_VALUES,
    RequirementLevels,
    TooltipPlacement,
} from '../../../../common';
import { useTranslation } from 'react-i18next';
import { jobsSelectors } from '../../../../actions';
import RequirementsSelector from './RequirementsSelector';
import RequirementsConfiguration from './RequirementsList';
import BenefitsSelector from './BenefitsSelector';
import { useEffect } from 'react';

interface Props {
    requirementsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.JOB_REQUIREMENTS,
        'requirementId'
    >;
    benefitsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.JOB_BENEFITS,
        'benefitId'
    >;
}

const JobRequirementsAndBenefits = (props: Props) => {
    const { requirementsArray, benefitsArray } = props;

    const { t } = useTranslation();
    const theme = useTheme();
    const jobRequirementsOptions = useAppSelector(
        jobsSelectors.getJobRequirementsOptions
    );

    const formattedJobRequirementsRecomendations = useAppSelector(
        jobsSelectors.getFormattedJobRequirementsRecomendations
    );

    useEffect(() => {
        if (formattedJobRequirementsRecomendations.length > 0) {
            requirementsArray.append(formattedJobRequirementsRecomendations);
        }
    }, [formattedJobRequirementsRecomendations]);

    const handleOptionToggle = (option: IJobRequirementOption) => {
        const existingIndex = requirementsArray.fields.findIndex(
            (item) => String(item.requirementId) === String(option.id)
        );

        if (existingIndex >= 0) {
            // Remove if already exists
            requirementsArray.remove(existingIndex);
        } else {
            // Add if doesn't exist
            const initialRequirementValue: ISaveJobRequirement = {
                requirementId: option.id || null,
                isAIRecommendation: false,
                name: option.name,
                requirementGroup: option.groupName,
                importanceLevel: RequirementLevels.regular,
                rangeFrom: '',
                rangeTo: '',
                weight: { from: 0, to: 2 },
                isVisible: true,
                rangeInd: true,
            };
            requirementsArray.append(initialRequirementValue);
        }
    };

    return (
        <Grid container gap={1.5}>
            <Grid container item xs={12} minHeight={600}>
                <Grid item width={300}>
                    <Box display="flex">
                        <Typography variant="h6" pb={2}>
                            {t('saveJob.requirements')}
                        </Typography>
                        <PargodaInfoIcon
                            text={t('saveJob.requirementsInfo')}
                            placement={TooltipPlacement.TOP_START}
                            size={20}
                            wrapperSx={{
                                paddingInlineStart: theme.spacing(0.5),
                                marginTop: theme.spacing(0.5),
                            }}
                        />
                    </Box>
                    <RequirementsSelector
                        options={jobRequirementsOptions}
                        requirementsArray={requirementsArray}
                        handleOptionToggle={handleOptionToggle}
                    />
                </Grid>
                <Grid item width="calc(100% - 300px)">
                    <RequirementsConfiguration
                        requirementsArray={requirementsArray}
                    />
                </Grid>
            </Grid>
            {/* <Grid container item xs={12}>
                <Grid item width={300}>
                    <Box display="flex">
                        <Typography variant="h6">
                            {t('saveJob.benefits')}
                        </Typography>
                        <PargodaInfoIcon
                            text={t('saveJob.benefitsInfo')}
                            placement={TooltipPlacement.TOP_START}
                            size={20}
                            wrapperSx={{
                                paddingInlineStart: theme.spacing(0.5),
                                marginTop: theme.spacing(0.5),
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item width="calc(100% - 300px)">
                    <BenefitsSelector benefitsArray={benefitsArray} />
                </Grid>
            </Grid> */}
        </Grid>
    );
};

export default JobRequirementsAndBenefits;
